import React from 'react';
import ApolloClient from 'apollo-boost';
import { ApolloProvider } from 'react-apollo';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

// components
import Portfolio from './Portfolio/Index.jsx';
import Profile from './Portfolio/Profile.jsx';
import Team from './Team/Index.jsx';
import Member from './Team/Member.jsx';
import ScrollToTop from './Global/ScrollToTop.jsx';

const client = new ApolloClient({
  uri: '/graphql',
});

function App() {
  return (
    <ApolloProvider client={client}>
      <Router>
        <ScrollToTop>
          <Route
            render={({ location }) => {
              return (
                <div className="pageTransition">
                  <TransitionGroup component={null}>
                    <CSSTransition
                      timeout={500}
                      classNames="transition"
                      key={location.key}
                    >
                      <Switch location={location}>
                        <Route
                          exact
                          path="/portfolio"
                          component={Portfolio}
                        ></Route>
                        <Route
                          exact
                          path="/portfolio/:slug"
                          component={Profile}
                        ></Route>
                        <Route exact path="/team" component={Team}></Route>
                        <Route
                          exact
                          path="/team/:slug"
                          component={Member}
                        ></Route>
                      </Switch>
                    </CSSTransition>
                  </TransitionGroup>
                </div>
              );
            }}
          />
        </ScrollToTop>
      </Router>
    </ApolloProvider>
  );
}

export default App;



// WEBPACK FOOTER //
// ./scripts/components/app.js